import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  fontSizes, lineHeights, palette,
}: Theme) => ({
  root: {
    display: 'block',
    margin: '0 auto',
    padding: 0,
    color: palette.primary.dark,
    fontSize: fontSizes.sm,
    lineHeight: lineHeights.md,
  },
  delivery: {
    width: '11.125rem',
    height: '3rem',
    padding: '0.75rem 1.25rem',
    borderRadius: '1rem',
    borderWidth: '0.125rem',
    marginTop: '2rem',
  },
}));
